import * as React from 'react';
import { useEffect, useRef } from 'react';

import { mountWorkiThinking, WorkiThinkingEngine, WorkiThinkingState } from './workiThinkingEngine.ts';
import classnames from '../../utils/classnames.tsx';
import './worki.css';

export type { WorkiThinkingState };

interface WorkiThinkingProps extends Omit<React.ComponentPropsWithRef<'div'>, 'children'> {
    state: WorkiThinkingState;
    label: string;
    onDone?: () => void;
}

const WorkiThinking = ({ state, label, onDone, className, ...props }: WorkiThinkingProps) => {
    const svgRef = useRef<SVGSVGElement>(null);
    const engineRef = useRef<WorkiThinkingEngine | null>(null);
    const onDoneRef = useRef(onDone);
    onDoneRef.current = onDone;
    const initialStateRef = useRef(state);

    useEffect(() => {
        const engine = mountWorkiThinking(svgRef.current!, {
            initialState: initialStateRef.current,
            onDone: () => onDoneRef.current?.(),
        });
        engineRef.current = engine;
        return () => engine.destroy();
    }, []);

    useEffect(() => {
        engineRef.current?.setState(state);
    }, [state]);

    return (
        <div {...props} role="status" aria-live="polite" className={classnames('worki-thinking', className)}>
            <svg
                ref={svgRef}
                className="worki-thinking__icon"
                width={20}
                height={20}
                viewBox="0 0 20 20"
                aria-hidden="true"
            />
            {/* the key restarts the label's fade-in when it changes */}
            <span key={label} className="worki-thinking__label text-sm font-normal">
                {label}
            </span>
        </div>
    );
};

export default WorkiThinking;
